export const LEGAL_DOCUMENTS = Object.freeze({
  termsOfService: {
    "key": "termsOfService",
    "path": "/terms-of-service",
    "title": "Terms of Service",
    "version": "2026-07-16",
    "effectiveDate": "July 16, 2026",
    "lead": "Welcome to Betterintentions.com (the \"Platform,\" \"Service,\" \"we,\" \"us,\" or \"our\"). These Terms of Service (\"Terms\") constitute a legally binding agreement between you and BetterIntentions, LLC, a Delaware limited liability company, governing your access to and use of our Platform.",
    "sections": [
      {
        "heading": "1. ACCEPTANCE OF TERMS",
        "paragraphs": [
          "1.1 Agreement to Terms",
          "Welcome to Betterintentions.com (the \"Platform,\" \"Service,\" \"we,\" \"us,\" or \"our\"). These Terms of Service (\"Terms\") constitute a legally binding agreement between you and BetterIntentions, LLC, a Delaware limited liability company, governing your access to and use of our Platform.",
          "By creating an account, accessing, or using the Platform, you agree to be bound by these Terms, our Privacy Policy, and our Community Guidelines. If you do not agree to these Terms, you may not use the Platform.",
          "1.2 Eligibility",
          "To use the Platform, you must:",
          "Be at least 16 years of age",
          "Be a resident of the United States (during our initial launch phase)",
          "Have the legal capacity to enter into a binding contract",
          "Not be barred from using the Platform under applicable law",
          "Not have had a previous account terminated for violating these Terms",
          "1.3 Account Registration",
          "You agree to:",
          "Provide accurate, current, and complete information during registration",
          "Maintain and promptly update your account information",
          "Maintain the security and confidentiality of your password",
          "Notify us immediately of any unauthorized access to your account",
          "Accept responsibility for all activities that occur under your account",
          "You may not:",
          "Create an account using false information or impersonate another person",
          "Create multiple accounts for yourself",
          "Create an account on behalf of a business",
          "Share your account with others",
          "Purchase, sell, rent, or transfer your account"
        ]
      },
      {
        "heading": "2. DESCRIPTION OF SERVICE",
        "paragraphs": [
          "2.1 Platform Purpose",
          "Betterintentions.com is a specialty social media platform designed to facilitate respectful conversations between individuals with diverse perspectives, beliefs, and backgrounds. Our mission is to provide a platform that will enable users to (1) meet individuals from other parts of the country and/or other walks of life, and (2) encourage meaningful and respectful dialogue between individuals with different viewpoints on one or more political or social issues.",
          "2.2 Core Features",
          "The Platform provides:",
          "User profiles with demographic information and belief attributes",
          "Search and filtering tools to enable users to find other users based upon demographics and/or based upon similar or different viewpoints",
          "Real-time messaging for one-on-one conversations",
          "Safety features including blocking, reporting, and content moderation",
          "Anonymous and pseudonymous display options",
          "2.3 Service Availability",
          "The Platform is provided \"as is\" and \"as available\"",
          "We do not guarantee continuous, uninterrupted, or error-free operation",
          "We may modify, suspend, or discontinue any feature at any time without notice",
          "We may perform website maintenance that temporarily limits or otherwise interrupts functionality"
        ]
      },
      {
        "heading": "3. USER OBLIGATIONS AND CONDUCT",
        "paragraphs": [
          "3.1 Required Profile Completion",
          "You agree to:",
          "Complete all demographic information fields accurately",
          "Complete at least 8 out of 11 belief attribute categories",
          "Maintain at least 80% profile completion to use this site",
          "Update your demographic information as needed when such information is no longer accurate",
          "3.2 Respectful Communication Requirement",
          "This is fundamental to our Platform: You must communicate respectfully with all other users, regardless of how much you disagree with their viewpoints. (See Community Guidelines for detailed standards.)",
          "3.3 Prohibited Conduct",
          "You may not:",
          "Content Violations",
          "Post threats, harassment, or intimidation of any kind",
          "Use hate speech or promote discrimination based on race, ethnicity, religion, gender, sexual orientation, disability, or other protected characteristics",
          "Share sexually explicit, obscene, or pornographic content",
          "Post, share, request, produce, solicit, or facilitate access to any child sexual abuse or exploitation (CSAE) material, or any content that sexualizes, endangers, or exploits a minor, including child sexual abuse material (CSAM), grooming, enticement, sextortion, or the trafficking of a minor",
          "Post violent or graphic content",
          "Share content that promotes or glorifies self-harm or suicide",
          "Distribute malware, viruses, or malicious code",
          "Share false information deliberately designed to mislead or deceive",
          "Violate anyone's intellectual property rights",
          "Share private information about others without consent (doxxing)",
          "Platform Abuse",
          "Use automated systems, bots, or scripts to access the Platform",
          "Attempt to circumvent security measures or access restrictions",
          "Scrape, harvest, or collect user information",
          "Send spam, unsolicited advertisements, or bulk messages",
          "Create business or professional accounts",
          "Create fake accounts or impersonate others",
          "Manipulate or game Platform features",
          "Interfere with or disrupt the Platform's operation",
          "Illegal Activity",
          "Engage in or promote illegal activity",
          "Solicit or facilitate illegal transactions",
          "Violate any applicable local, state, national, or international law",
          "3.4 Content Moderation",
          "All messages are monitored through third-party content moderation services",
          "Flagged content will be reviewed for compliance with these Terms and Community Guidelines",
          "We reserve the right to remove content or restrict accounts that violate our standards",
          "Repeated violations may result in permanent account termination",
          "3.5 Reporting Violations",
          "You agree to:",
          "Report users or content that violates these Terms or Community Guidelines",
          "Provide accurate information in reports",
          "Not abuse the reporting system to harass users or silence viewpoints you disagree with",
          "3.6 Child Safety and Zero Tolerance for Child Sexual Abuse and Exploitation (CSAE)",
          "The Platform is intended for users aged 16 and older. Chat is text-based only — users may not send photographs, videos, or other images in messages; the only image you may upload is an optional profile photo, which is automatically screened by an image-moderation service. We have zero tolerance for child sexual abuse and exploitation (CSAE) and for any content or conduct that sexualizes, endangers, or exploits a minor. The following standards apply to every user, form part of our publicly available terms, and supplement the prohibited conduct described in Section 3.3.",
          "Prohibited child safety conduct. You may not use the Platform to create, post, store, request, solicit, share, promote, facilitate access to, or otherwise engage in child sexual abuse material (CSAM) or any other form of CSAE. This includes the grooming, enticement, sextortion, sexualization, or trafficking of any person under the age of 18, and any attempt to use the Platform to identify, contact, or arrange contact with a minor for any such purpose. This prohibition applies regardless of whether the minor involved is real, fictional, or computer-generated.",
          "How to report child safety concerns in the app. The Platform provides an in-app mechanism that allows you to submit feedback, concerns, or reports, including the “Report” and “Block” options available within each conversation and on each user profile. If you encounter content or conduct that may violate these child safety standards, you must report it immediately using these in-app tools or by contacting our Child Safety Point of Contact identified in Section 15.4. Reports of suspected CSAE are prioritized for review.",
          "Our enforcement and removal actions. Upon obtaining actual knowledge of CSAM or other CSAE on the Platform, we will take appropriate action in accordance with these Terms and applicable law. Such action may include removing the offending content, preserving relevant records as required or permitted by law, suspending or permanently terminating the responsible account(s), and reporting the matter to law enforcement or other appropriate authorities.",
          "Compliance with child safety laws; NCMEC reporting. We comply with applicable child safety laws and regulations. We maintain a process to report apparent or confirmed CSAM to the National Center for Missing & Exploited Children (NCMEC) through its CyberTipline at www.cybertipline.org or, where applicable, to the relevant authority in the user’s jurisdiction, as required by law."
        ]
      },
      {
        "heading": "4. USER CONTENT AND DATA",
        "paragraphs": [
          "4.1 Your Content",
          "You retain ownership of the content you create, but you grant us specific rights to use it.",
          "4.2 License to Platform",
          "By posting content on the Platform, you grant us a perpetual, irrevocable, worldwide, royalty-free, sublicensable, and transferable license to:",
          "Store, process, and display your content",
          "Use your content to provide and improve the Platform",
          "Use your content for artificial intelligence and machine learning purposes, including training AI models (whether operated by us or third parties)",
          "Share your content with third-party service providers (moderation, hosting, analytics)",
          "Use your content for research, analysis, and development purposes",
          "Create derivative works based on your content for Platform improvement",
          "4.3 Content Responsibility",
          "You are solely responsible for:",
          "All content you post or share",
          "Ensuring you have the right to post the content",
          "Any consequences of posting content (legal, financial, or otherwise)",
          "The accuracy and reliability of information you provide",
          "4.4 Public Nature of Content",
          "You acknowledge and agree that:",
          "Your demographic information and belief attributes are visible to all Platform users",
          "Other users can view your profile information when searching or browsing",
          "While messages are private between conversation participants, they are not confidential from the Platform",
          "The Platform maintains complete records of all messages and content",
          "4.5 Storage of Data",
          "CRITICAL: You acknowledge and expressly agree that:",
          "Messages, content, and data you create are stored while your account is active",
          "Deleting content from your view does not remove it from Platform storage",
          "When you delete your account, your data is removed as described in our Privacy Policy, subject to limited legal, safety, backup, and abuse-prevention exceptions",
          "Your data may be used for AI training, legal compliance, and other purposes indefinitely",
          "Account-active retention is necessary for platform operation, safety, and legal compliance",
          "See our Privacy Policy for complete details on data retention."
        ]
      },
      {
        "heading": "5. INTELLECTUAL PROPERTY RIGHTS",
        "paragraphs": [
          "5.1 Platform Ownership",
          "The Platform and all its components (including but not limited to software, design, text, graphics, logos, features, and functionality) are owned by BetterIntentions, LLC, a Delaware limited liability company and protected by copyright, trademark, patent, and other intellectual property laws.",
          "5.2 Limited License to Use Platform",
          "We grant you a limited, non-exclusive, non-transferable, revocable license to access and use the Platform for personal, non-commercial purposes, subject to these Terms.",
          "5.3 Restrictions",
          "You may not:",
          "Copy, modify, distribute, sell, or lease any part of the Platform",
          "Reverse engineer, decompile, or disassemble the Platform",
          "Remove or alter any proprietary notices",
          "Use the Platform to build a competing service",
          "Frame or mirror any part of the Platform",
          "5.4 Trademarks",
          "Betterintentions.com, our logo, and any other product or service names displayed on the Platform are trademarks of BetterIntentions, LLC, a Delaware limited liability company. You may not use these marks without our prior written permission.",
          "5.5 User Feedback",
          "If you provide suggestions, ideas, or feedback about the Platform, we may use them without any obligation to compensate you."
        ]
      },
      {
        "heading": "6. ACCOUNT TERMINATION AND SUSPENSION",
        "paragraphs": [
          "6.1 Termination by You",
          "You may close your account at any time by deleting your account from Settings → Delete Account.",
          "Important: Closing your account will:",
          "Remove your profile from public view",
          "Prevent you from accessing the Platform",
          "Prevent other users from finding or contacting you",
          "However, it will NOT:",
          "Prevent retention of records we are legally or operationally required to keep",
          "Remove messages from other participants' views",
          "Affect our rights to use your content as described in these Terms",
          "6.2 Termination or Suspension by Us",
          "We reserve the right to suspend or terminate your account, with or without notice, if you:",
          "Violate these Terms, Privacy Policy, or Community Guidelines",
          "Engage in conduct that harms the Platform or other users",
          "Create risk or legal liability for us",
          "Provide false or misleading information",
          "Use the Platform in a way that conflicts with applicable law",
          "6.3 Effect of Termination",
          "Upon termination:",
          "Your right to use the Platform immediately ceases",
          "You remain bound by sections of these Terms that survive termination (see Section 15.11)",
          "We retain the rights to your content and data described in these Terms",
          "You remain liable for any violations that occurred before termination",
          "6.4 No Refunds",
          "If we terminate or suspend your account for violations, you are not entitled to any refund or compensation. (This applies to future paid features if implemented.)"
        ]
      },
      {
        "heading": "7. PRIVACY AND DATA PROTECTION",
        "paragraphs": [
          "7.1 Privacy Policy",
          "Your use of the Platform is also governed by our Privacy Policy, which is incorporated into these Terms by reference and which is subject to amendment from time to time. Please review it carefully.",
          "7.2 Data Collection and Use",
          "By using the Platform, you consent to:",
          "Collection of your personal information, demographic data, and belief attributes",
          "Public display of your demographic information and belief attributes to other users",
          "Storage of messages and content while your account is active, with deletion on account deletion as described in our Privacy Policy",
          "Use of your data for AI training and machine learning purposes",
          "Sharing of your data with third-party service providers and AI platforms",
          "Processing of your data as described in the Privacy Policy",
          "7.3 Communications from Us",
          "You consent to receive:",
          "Service-related emails (account verification, password resets, security alerts)",
          "Updates about changes to Terms, Privacy Policy, or Community Guidelines",
          "Push notifications (which you may disable in settings)",
          "Platform announcements and updates",
          "You may opt out of promotional communications but cannot opt out of service-related messages."
        ]
      },
      {
        "heading": "8. THIRD-PARTY SERVICES AND CONTENT",
        "paragraphs": [
          "8.1 Third-Party Services",
          "The Platform uses third-party services including:",
          "Amazon Comprehend (text content moderation) and Amazon Rekognition (automated screening of profile photos)",
          "Cloud hosting and infrastructure (AWS)",
          "Amazon Simple Email Service (SES v2) for email; SMS verification is not currently used",
          "Amazon SNS for mobile push notifications (you can disable them in settings)",
          "Amazon CloudWatch (internal analytics and performance monitoring)",
          "8.2 No Endorsement",
          "We do not endorse, control, or assume responsibility for:",
          "Third-party services or their privacy practices",
          "External websites or services linked from the Platform (including future advertising links)",
          "User-generated content or viewpoints expressed by users",
          "8.3 Third-Party Terms",
          "Your use of third-party services may be subject to additional terms and conditions imposed by those third parties."
        ]
      },
      {
        "heading": "9. DISCLAIMERS AND LIMITATIONS OF LIABILITY",
        "paragraphs": [
          "9.1 No Warranties",
          "THE PLATFORM IS PROVIDED \"AS IS\" AND \"AS AVAILABLE\" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO:",
          "Warranties of merchantability, fitness for a particular purpose, or non-infringement",
          "Warranties that the Platform will be uninterrupted, error-free, or secure",
          "Warranties regarding the accuracy, reliability, or quality of any content or information",
          "9.2 No Responsibility for User Content",
          "We do not:",
          "Endorse any user content or viewpoints",
          "Verify the accuracy of user-provided information",
          "Guarantee the identity or authenticity of users",
          "Take responsibility for user interactions or outcomes",
          "9.3 Content Moderation Disclaimer",
          "While we use third-party content moderation services and provide reporting tools:",
          "We cannot guarantee all inappropriate content will be detected or removed",
          "Moderation decisions may not be perfect or instantaneous",
          "You may encounter content you find offensive despite our best efforts",
          "We are not liable for user content that violates these Terms",
          "9.4 Limitation of Liability",
          "TO THE MAXIMUM EXTENT PERMITTED BY LAW:",
          "We are not liable for any indirect, incidental, special, consequential, or punitive damages, including:",
          "Loss of profits, revenue, data, or goodwill",
          "Service interruptions or errors",
          "Loss of content or information",
          "Harm resulting from user interactions",
          "Third-party actions or content",
          "Unauthorized access to your account",
          "AI or algorithmic errors",
          "Our total liability to you for all claims arising from or relating to the Platform shall not exceed:",
          "$100 (One Hundred US Dollars), OR",
          "The amount you paid us in the 12 months before the claim (if paid features are implemented)",
          "Whichever is greater.",
          "9.5 User Interactions",
          "You are solely responsible for your interactions with other users. We are not responsible for:",
          "Disputes between users",
          "Offline meetings or interactions",
          "Harm resulting from user conversations or relationships",
          "Misrepresentations by other users",
          "Exercise caution and good judgment in all interactions.",
          "9.6 Basis of the Bargain",
          "You acknowledge that these disclaimers and limitations are fundamental elements of the agreement between you and us, and that we would not provide the Platform without them."
        ]
      },
      {
        "heading": "10. INDEMNIFICATION",
        "paragraphs": [
          "10.1 Your Indemnification Obligation",
          "You agree to indemnify, defend, and hold harmless BetterIntentions, LLC, a Delaware limited liability company, its affiliates, officers, directors, employees, agents, licensors, and service providers from and against any claims, liabilities, damages, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising from or relating to:",
          "Your use or misuse of the Platform",
          "Your violation of these Terms, Privacy Policy, or Community Guidelines",
          "Your violation of any law or regulation",
          "Your violation of any rights of another person or entity",
          "Your content or any content posted through your account",
          "Your interactions with other users",
          "Any false or misleading information you provided",
          "10.2 Defense and Settlement",
          "We reserve the right to assume the exclusive defense and control of any matter subject to indemnification by you, and you agree to cooperate with our defense of such claims."
        ]
      },
      {
        "heading": "11. DISPUTE RESOLUTION",
        "paragraphs": [
          "11.1 Governing Law",
          "These Terms are governed by the laws of the State of Florida, and the United States, without regard to conflict of law principles.",
          "11.2 Informal Resolution",
          "Before filing any formal claim, you agree to contact us at privacy@betterintentions.com and attempt to resolve the dispute informally for at least sixty (60) days.",
          "11.3 Binding Arbitration",
          "PLEASE READ THIS SECTION CAREFULLY – IT AFFECTS YOUR LEGAL RIGHTS",
          "Except as specified below, you agree that all disputes arising from or relating to these Terms or the Platform will be resolved through binding individual arbitration rather than in court.",
          "Arbitration Rules",
          "Arbitration will be conducted by the American Arbitration Association (AAA) under its Consumer Arbitration Rules",
          "Arbitration will take place in Naples, Florida, or another mutually agreed location",
          "The arbitrator's decision will be final and binding",
          "Judgment on the award may be entered in any court of competent jurisdiction",
          "Exceptions to Arbitration",
          "The following may be brought in court:",
          "Small claims court actions (if requirements are met)",
          "Injunctive or equitable relief for intellectual property infringement",
          "Claims related to the enforceability of this arbitration provision",
          "11.4 Class Action Waiver",
          "YOU AGREE TO BRING CLAIMS ONLY IN YOUR INDIVIDUAL CAPACITY AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS, CONSOLIDATED, OR REPRESENTATIVE PROCEEDING.",
          "Neither you nor we consent to class arbitration or any claims brought on behalf of others.",
          "11.5 Jury Trial Waiver",
          "You waive your right to a jury trial for any disputes arising from or relating to these Terms or the Platform.",
          "11.6 Time Limitation",
          "Any claim must be filed within one (1) year after the claim arises, or it will be permanently barred."
        ]
      },
      {
        "heading": "12. MODIFICATIONS TO TERMS",
        "paragraphs": [
          "12.1 Right to Modify",
          "We reserve the right to modify these Terms at any time. Changes may be made to:",
          "Reflect changes in law or regulatory requirements",
          "Address new features or services",
          "Improve clarity or address user feedback",
          "Protect the Platform or users",
          "12.2 Notice of Changes",
          "We will notify you of material changes by:",
          "Posting the updated Terms on the Platform",
          "Updating the \"Last Updated\" date",
          "Sending email notification for significant changes",
          "Displaying a prominent notice on the Platform",
          "12.3 Acceptance of Changes",
          "Your continued use of the Platform after changes are posted constitutes acceptance of the modified Terms. If you do not agree to the changes, you must stop using the Platform and close your account.",
          "12.4 Dispute Resolution for Changes",
          "For any material changes to the dispute resolution or arbitration provisions, you have 30 days from notice to reject the changes by sending written notice to privacy@betterintentions.com. Rejecting changes means the previous version applies to you, but you may lose access to new features."
        ]
      },
      {
        "heading": "13. GENERAL PROVISIONS",
        "paragraphs": [
          "13.1 Entire Agreement",
          "These Terms, together with the Privacy Policy and Community Guidelines, constitute the entire agreement between you and us regarding the Platform and supersede all prior agreements.",
          "13.2 Severability",
          "If any provision of these Terms is found to be unenforceable or invalid, that provision will be limited or eliminated to the minimum extent necessary, and the remaining provisions will remain in full force and effect.",
          "13.3 Waiver",
          "Our failure to enforce any right or provision of these Terms will not constitute a waiver of that right or provision. Any waiver must be in writing and signed by us.",
          "13.4 Assignment",
          "You may not assign or transfer these Terms or your account without our prior written consent, which we may withhold at our sole and absolute discretion. We may assign these Terms or any rights under them without restriction.",
          "13.5 Force Majeure",
          "We are not liable for any delay or failure to perform due to causes beyond our reasonable control, including acts of God, war, terrorism, riots, embargoes, acts of civil or military authorities, fire, floods, accidents, pandemics, strikes, or shortages of transportation, facilities, fuel, energy, labor, or materials.",
          "13.6 Headings",
          "Section headings are for convenience only and do not affect interpretation of these Terms.",
          "13.7 No Agency",
          "No agency, partnership, joint venture, or employment relationship is created between you and us as a result of these Terms or your use of the Platform.",
          "13.8 Electronic Communications",
          "You consent to receive communications from us electronically, and you agree that electronic communications satisfy any legal requirement that communications be in writing.",
          "13.9 Export Control",
          "You may not use or export the Platform in violation of U.S. export laws and regulations.",
          "13.10 U.S. Government Rights",
          "If you are a U.S. government entity, the Platform constitutes \"commercial computer software\" and \"commercial computer software documentation\" as defined in FAR 12.212 and DFARS 227.7202.",
          "13.11 Survival",
          "The following sections survive termination of these Terms: User Content and Data (Section 4), Intellectual Property Rights (Section 5), Disclaimers and Limitations of Liability (Section 9), Indemnification (Section 10), Dispute Resolution (Section 11), and General Provisions (Section 13)."
        ]
      },
      {
        "heading": "14. FUTURE CHANGES TO SERVICE",
        "paragraphs": [
          "14.1 Monetization",
          "We reserve the right to introduce advertising in the future. We will:",
          "Update these Terms before implementing advertising",
          "Notify users of the change",
          "Use demographic, belief, and/or content data for targeted advertising as described in the Privacy Policy",
          "14.2 New Features",
          "We may add, modify, or remove features at any time. New features may be subject to additional terms.",
          "14.3 Geographic Expansion",
          "While currently limited to U.S. users, we may expand to other countries in the future and will update these Terms accordingly."
        ]
      },
      {
        "heading": "15. CONTACT INFORMATION",
        "paragraphs": [
          "15.1 General Inquiries",
          "For questions about these Terms:",
          "Email: privacy@betterintentions.com \nMailing Address:\nBetterIntentions, LLC\n2388 Immokalee Rd., #277\nNaples, FL 34110",
          "15.2 Legal Notices",
          "All legal notices must be sent to the address above via certified mail.",
          "15.3 DMCA Copyright Agent",
          "For copyright infringement claims under the Digital Millennium Copyright Act:",
          "DMCA Agent: Matthew L. Grabinski\nEmail: matt@betterintentions.com\nAddress: \nBetterIntentions, LLC\n2388 Immokalee Rd., #277\nNaples, FL 34110",
          "15.4 Child Safety Point of Contact",
          "We have designated a Child Safety Point of Contact to receive notifications, including from Google Play, regarding potential child sexual abuse and exploitation (CSAE) content found in our app or on the Platform. This representative is positioned to speak to our enforcement and review procedures and to take action where required:",
          "Child Safety Point of Contact: Matthew L. Grabinski\nEmail: matt@betterintentions.com\nAddress:\nBetterIntentions, LLC\n2388 Immokalee Rd., #277\nNaples, FL 34110"
        ]
      },
      {
        "heading": "16. ACKNOWLEDGMENT",
        "paragraphs": [
          "BY CLICKING \"I AGREE,\" CREATING AN ACCOUNT, OR USING THE PLATFORM, YOU ACKNOWLEDGE THAT:",
          "You have read and understood these Terms of Service",
          "You have read and understood the Privacy Policy and Community Guidelines",
          "You agree to be bound by these Terms",
          "You are at least 16 years of age",
          "You understand that content is stored while your account is active and is removed on account deletion subject to the exceptions described in our Privacy Policy",
          "You consent to your data being used for AI training",
          "You agree to communicate respectfully with all users",
          "You understand the Platform's mission to facilitate cross-belief dialogue",
          "You agree to arbitration and waive your right to jury trial and class actions",
          "You acknowledge that demographic and belief information is publicly visible"
        ]
      }
    ]
  },
  privacyPolicy: {
    "key": "privacyPolicy",
    "path": "/privacy-policy",
    "title": "Privacy Policy",
    "version": "2026-07-16",
    "effectiveDate": "July 16, 2026",
    "lead": "Welcome to BetterIntentions.com (\"Platform,\" \"we,\" \"us,\" or \"our\"). This Privacy Policy explains how we collect, use, disclose, and protect your information when you use our specialty social media platform designed to facilitate conversations across different viewpoints and belief systems.",
    "sections": [
      {
        "heading": "1. INTRODUCTION",
        "paragraphs": [
          "Welcome to BetterIntentions.com (\"Platform,\" \"we,\" \"us,\" or \"our\"). This Privacy Policy explains how we collect, use, disclose, and protect your information when you use our specialty social media platform designed to facilitate conversations across different viewpoints and belief systems.",
          "IMPORTANT: By creating an account and using our Platform, you agree to the collection, use, and disclosure of your information as described in this Privacy Policy. If you do not agree, please do not use our services.",
          "This Privacy Policy should be read in conjunction with our Terms of Service and Community Guidelines."
        ]
      },
      {
        "heading": "2. INFORMATION WE COLLECT",
        "paragraphs": [
          "2.1 Information You Provide Directly",
          "Account Registration Information",
          "When you create an account, we collect:",
          "Real name (required but not publicly displayed unless you choose)",
          "Email address (required for account verification)",
          "Phone number (optional)",
          "Password (encrypted and stored securely)",
          "Display name preference (real name, alias, or anonymous identifier)",
          "Demographic Information (Publicly Visible to Other Users)",
          "During registration and profile management, we collect:",
          "Age",
          "Gender",
          "City and state of residence",
          "Occupation",
          "Political party affiliation",
          "Sexual orientation",
          "Note: Political party affiliation and sexual orientation are visible to other users only if you enable them in Settings, and are collected with your explicit consent at sign-up. All other demographic information above is visible to all users.",
          "Social and Political Belief Attributes (Publicly Visible to Other Users)",
          "You must complete at least 8 of 11 belief categories, indicating your position on:",
          "Gun control",
          "Economic policy",
          "Trade policy",
          "Immigration policy",
          "Law enforcement policy",
          "Election integrity",
          "Additional categories as defined by the platform",
          "Note: You may skip up to 3 belief attribute categories. These attributes are visible to all other users on the Platform.",
          "Profile Information (Optional)",
          "Profile picture",
          "Biography",
          "Other profile customizations",
          "Communications and Content",
          "All messages sent through our Platform",
          "Reports and feedback submitted to us",
          "Any other content you create or share on the Platform",
          "2.2 Information We Do NOT Collect",
          "We explicitly DO NOT collect:",
          "Credit card or bank account information",
          "Social Security numbers",
          "Medical or health information",
          "Payment information of any kind",
          "2.3 Information Collected Automatically",
          "Usage Information",
          "Pages visited and features used",
          "Search queries and filters applied",
          "Time spent on Platform",
          "Conversation activity (number of conversations, message frequency)",
          "Device information (browser type, operating system, device identifiers)",
          "Technical Information",
          "IP address",
          "Session data",
          "Cookies and similar tracking technologies",
          "Log files and error reports",
          "Security and Bot Prevention Data",
          "CAPTCHA responses",
          "Rate limiting triggers",
          "Suspicious activity patterns",
          "Verification attempt records",
          "2.4 Information from Third Parties",
          "Content Moderation Services",
          "We use third-party content moderation services that may process your messages and content to ensure compliance with our Community Guidelines.",
          "Service Providers",
          "We may receive information from cloud hosting providers (AWS), database services, and other infrastructure providers necessary to operate the Platform."
        ]
      },
      {
        "heading": "3. HOW WE USE YOUR INFORMATION",
        "paragraphs": [
          "3.1 Core Platform Functions",
          "Account Management",
          "Create and authenticate your account",
          "Verify your identity through email verification",
          "Maintain your session across devices",
          "Enable password reset functionality",
          "Allow profile viewing and editing",
          "User Discovery and Matching",
          "Display your demographic information and belief attributes to other users",
          "Enable other users to search for and discover you based on filter criteria",
          "Show your display name (real, alias, or anonymous as per your choice)",
          "Facilitate connections between users with different perspectives",
          "Messaging and Communications",
          "Deliver messages between users in real-time",
          "Store message history while your account is active; it is permanently deleted when you delete your account (see Sections 5 and 5A)",
          "Provide conversation lists and message notifications",
          "Display online/offline status",
          "Use of email to notify you of new features and updates to existing features of our website, and general marketing purposes",
          "3.2 Safety and Moderation",
          "Monitor content through third-party moderation services",
          "Detect and prevent spam, bots, and abuse",
          "Enforce Community Guidelines",
          "Process user reports",
          "Maintain audit logs for safety and legal purposes",
          "Implement blocking and reporting features",
          "3.3 Advertising (Future Use)",
          "Your demographic information, belief attributes, and conversation content may be used for:",
          "Targeted advertising displayed on our Platform",
          "Ad placement and optimization",
          "Advertiser analytics (in aggregated, de-identified form)",
          "We will update this Privacy Policy before implementing advertising features.",
          "3.4 Artificial Intelligence and Machine Learning",
          "Your data, including message content, may be used to:",
          "Train artificial intelligence large language models",
          "Develop and improve AI features on our Platform",
          "License or provide data to third-party AI platforms and services",
          "Improve content moderation and safety systems",
          "3.5 Platform Improvement",
          "Analyze usage patterns and trends",
          "Improve user experience and features",
          "Debug and fix technical issues",
          "Conduct research and analytics",
          "Test new features",
          "3.6 Legal and Compliance",
          "Comply with legal obligations",
          "Respond to legal requests and law enforcement",
          "Enforce our Terms of Service and Community Guidelines",
          "Protect rights, property, and safety of users and the Platform",
          "Resolve disputes"
        ]
      },
      {
        "heading": "4. HOW WE SHARE YOUR INFORMATION",
        "paragraphs": [
          "4.1 Public Information Visible to All Users",
          "The following information is visible to ALL other users on the Platform:",
          "Your display name (as you've chosen: real name, alias, or anonymous)",
          "All demographic information (age, gender, location, occupation); political party affiliation and sexual orientation are visible only if you have enabled them in Settings",
          "All completed belief attributes (your positions on social and political issues)",
          "Your profile picture (if uploaded)",
          "Your biography and profile information",
          "Note: Other users can view this information when you appear in their search results or when they view your profile.",
          "4.2 Information Shared with Service Providers",
          "We share your information with third-party service providers who perform services on our behalf:",
          "Infrastructure and Hosting",
          "Cloud hosting providers (AWS)",
          "Database services (MongoDB, DynamoDB)",
          "Content delivery networks",
          "Content Moderation",
          "Third-party content moderation APIs that process all messages in real-time",
          "These services review messages for prohibited content (threats, harassment, hate speech, illegal content)",
          "Communications",
          "Email service providers (for verification and notifications)",
          "Push notification services",
          "Analytics and Performance",
          "Analytics providers",
          "Performance monitoring tools",
          "Error tracking services",
          "Security and Bot Prevention",
          "CAPTCHA service providers",
          "Fraud detection and prevention services",
          "All service providers are contractually obligated to protect your information and use it only for the purposes we specify.",
          "4.3 Artificial Intelligence and Data Licensing",
          "Your data, including message content, demographic information, and belief attributes, may be shared with:",
          "Third-party artificial intelligence platforms and services",
          "Machine learning companies",
          "Research institutions",
          "Data analytics firms",
          "This sharing enables AI model training and development, both for our own AI features and for third-party AI systems.",
          "4.4 Business Transfers",
          "In the event of a merger, acquisition, sale of assets, bankruptcy, or other business transaction, your information may be transferred to the acquiring entity or successor.",
          "4.5 Legal Requirements and Safety",
          "We may disclose your information when required by law or when we believe disclosure is necessary to:",
          "Comply with legal obligations, court orders, or government requests",
          "Enforce our Terms of Service or Community Guidelines",
          "Investigate and prevent fraud, security issues, or illegal activity",
          "Protect the rights, property, or safety of the Platform, our users, or the public",
          "4.6 With Your Consent",
          "We may share your information in other circumstances with your explicit consent."
        ]
      },
      {
        "heading": "5. MESSAGE RETENTION AND DELETION",
        "paragraphs": [
          "5.1 Message Storage",
          "Messages are stored while your account is active so we can provide conversations, safety features, abuse prevention, and legal compliance. When you delete your account, your messages are deleted as described in Section 8, subject to the limited exceptions noted there.",
          "We maintain conversation records while needed for platform integrity, safety, legal protection, and product operation",
          "Deleting a message or conversation from your view hides it for you but does not delete it for other participants or from active platform records",
          "When you delete your account, account data is removed as described in Section 8",
          "5.2 User Deletion Controls",
          "While your account is active, you have the following deletion controls for your own view:",
          "Delete Individual Messages",
          "You can delete your own messages from your conversation view",
          "Your conversation partner will still see the deleted message",
          "The message remains available to the other participant and in active platform records until account deletion",
          "Delete Entire Conversations",
          "You can remove entire conversations from your conversation list",
          "This only affects your view; the other user retains access to the conversation",
          "Messages remain available to the other participant and in active platform records until account deletion",
          "Important Notice",
          "Deleting messages or conversations from your view does not remove them from:",
          "Our platform storage and databases",
          "Your conversation partner's view (for deleted individual messages)",
          "Our audit logs and records",
          "Content moderation systems"
        ]
      },
      {
        "heading": "5A. ACCOUNT DELETION",
        "paragraphs": [
          "You may delete your account at any time from Settings -> Delete Account. Account deletion is permanent and irreversible - there is no soft delete or deactivation.",
          "What is permanently deleted (within seconds of your request): your profile (name, email, phone, demographics, belief attributes, biography); your profile picture (Amazon S3); every conversation you took part in, including the messages on both sides; your login credentials (Amazon Cognito); your block lists, hidden-conversation entries, read state, and presence; your push-notification device tokens; and all reports you filed about other users. Counterparts receive a real-time update so the conversation is removed from their app as well.",
          "What we retain after a voluntary deletion (90 days, then automatically purged): a one-way SHA-256 hash of your email, phone, and user ID (no human-readable personal information), the IP address used for the deletion request, and the account created/deleted dates.",
          "What we retain as safety evidence (anonymized): reports filed about you by other users, with your identifier removed and any free-text snippet dropped, kept as evidence to protect other users.",
          "What we retain indefinitely only if your account was disabled for a policy violation before deletion: the hashed identifiers above (no expiry), used to prevent re-registration. All other data is permanently deleted."
        ]
      },
      {
        "heading": "6. DATA SECURITY",
        "paragraphs": [
          "6.1 Security Measures",
          "We implement industry-standard security measures to protect your information:",
          "Encryption in transit: All data transmitted between your device and our servers is encrypted using TLS/SSL",
          "Encryption at rest: Sensitive user data is encrypted in our databases",
          "Password security: Passwords are hashed and salted using strong cryptographic algorithms",
          "Access controls: Limited employee access to user data on a need-to-know basis",
          "Security monitoring: Continuous monitoring for suspicious activity and security threats",
          "Regular security audits: Periodic review of our security practices",
          "6.2 Security Limitations",
          "No method of transmission or storage is 100% secure. While we strive to protect your information, we cannot guarantee absolute security. You acknowledge and accept this risk by using the Platform.",
          "6.3 Account Security",
          "You are responsible for:",
          "Maintaining the confidentiality of your password",
          "All activity that occurs under your account",
          "Notifying us immediately of any unauthorized access"
        ]
      },
      {
        "heading": "7. YOUR PRIVACY CHOICES AND RIGHTS",
        "paragraphs": [
          "7.1 Profile and Display Preferences",
          "Display name: Change between real name and an alias display at any time",
          "Profile editing: Edit demographic information and belief attributes (maintaining minimum 80% completion)",
          "Profile picture: Upload, update, or remove your profile picture",
          "7.2 Communication Preferences",
          "Push notifications: Enable or disable push notifications for new messages",
          "Email communications: Manage receipt of platform updates and announcements (account-related emails cannot be disabled)",
          "7.3 Privacy Controls",
          "Blocking: Block other users to prevent them from contacting you or appearing in your searches",
          "Reporting: Report users or content that violates Community Guidelines",
          "Anonymous usage: Use the Platform with an anonymous or pseudonymous display name",
          "7.4 Data Access and Portability",
          "You may request:",
          "A copy of your personal information",
          "Correction of inaccurate information",
          "Information about how your data has been used",
          "Contact us at privacy@betterintentions.com to make these requests.",
          "7.5 Account Closure",
          "You may close your account at any time by deleting your account from Settings → Delete Account.",
          "Important: Closing your account will:",
          "Prevent you from accessing the Platform",
          "Remove your profile from public view",
          "Prevent other users from finding or contacting you",
          "However, closing your account will NOT:",
          "Prevent deletion of the limited records we are legally or operationally required to retain",
          "Remove limited records retained after deletion as described in this Privacy Policy",
          "Delete records retained because your account was disabled for a policy violation before deletion",
          "Remove aggregated, de-identified analytics that no longer identify you",
          "Delete backup snapshots before they expire on our normal backup-retention schedule",
          "Account deletion is permanent and irreversible. Most account data is deleted promptly; limited deletion and abuse-prevention records may be retained as described in Section 8."
        ]
      },
      {
        "heading": "8. DATA RETENTION",
        "paragraphs": [
          "8.1 Retention Periods",
          "We retain your account, profile, message, and usage data while your account is active. When you delete your account, that data is permanently deleted as described in Section 5A. The only items retained after deletion are a 90-day forensic record (hashed identifiers plus the deletion-request IP), anonymized safety reports about you, and - for accounts disabled for a policy violation - hashed identifiers retained to prevent re-registration. While active, the data we hold includes:",
          "Account information (name, email, phone)",
          "Demographic information",
          "Belief attributes",
          "Complete message history",
          "Profile information",
          "Usage data and logs",
          "8.2 Legal and Business Purposes",
          "Information is retained only as long as reasonably necessary for:",
          "Platform integrity and safety",
          "Legal compliance and protection",
          "Dispute resolution",
          "AI training and development",
          "Analytics and research",
          "Enforcement of Terms of Service",
          "8.3 Backup and Archival",
          "All data is backed up regularly and stored in multiple locations for disaster recovery and business continuity purposes."
        ]
      },
      {
        "heading": "9. CHILDREN'S PRIVACY",
        "paragraphs": [
          "9.1 Age Requirement",
          "Our Platform is intended for users aged 16 years and older. We do not knowingly collect information from anyone under 16.",
          "9.2 Parental Notice",
          "If you are a parent or guardian and believe your child under 16 has created an account, please contact us immediately at privacy@betterintentions.com, and we will take steps to delete the account.",
          "9.3 Age Verification",
          "We rely on users to provide accurate age information. Misrepresenting your age is a violation of our Terms of Service.",
          "9.4 Minors (Ages 16-17): Audience Separation",
          "Because our minimum age is 16, some users are 16-17-year-old minors. We keep minors and adults fully separated. Based on each user's date of birth (not a setting they can change), every account is classified as a minor (under 18) or an adult (18 or older). Minors can only discover, appear to, and exchange messages with other minors; minors and adults cannot find, view, or contact one another. If an account's age cannot be determined, it is treated as an adult so that minors are never exposed to unknown users."
        ]
      },
      {
        "heading": "10. INTERNATIONAL USERS AND DATA TRANSFERS",
        "paragraphs": [
          "10.1 US-Based Service",
          "Our Platform is currently available only in the United States and is operated from the United States. All data is processed and stored in the United States.",
          "10.2 Future Global Expansion",
          "If we expand to other countries:",
          "We may transfer data internationally",
          "We will comply with applicable international privacy laws",
          "We will update this Privacy Policy accordingly",
          "10.3 Non-US Users",
          "If you access our Platform from outside the United States, you understand that your information will be transferred to, processed, and stored in the United States, which may have different data protection laws than your country."
        ]
      },
      {
        "heading": "11. COOKIES AND TRACKING TECHNOLOGIES",
        "paragraphs": [
          "11.1 Types of Technologies Used",
          "We use cookies, web beacons, and similar technologies to:",
          "Authenticate users and maintain sessions",
          "Remember preferences and settings",
          "Analyze usage and performance",
          "Prevent fraud and enhance security",
          "Deliver relevant content and advertising (future)",
          "11.2 Types of Cookies",
          "Essential cookies: Required for Platform functionality",
          "Performance cookies: Help us understand usage patterns",
          "Security cookies: Detect fraud and abuse",
          "Advertising cookies: (Future) Deliver targeted advertising",
          "11.3 Your Cookie Choices",
          "Most browsers allow you to control cookies through settings. However, disabling essential cookies may prevent you from using certain features of the Platform."
        ]
      },
      {
        "heading": "12. THIRD-PARTY LINKS AND SERVICES",
        "paragraphs": [
          "12.1 External Links",
          "Our Platform may contain links to third-party websites or services (particularly in future advertising). We are not responsible for the privacy practices of these third parties. We encourage you to review their privacy policies.",
          "12.2 Third-Party Services",
          "We use third-party services (hosting, moderation, analytics) that may have their own privacy policies. While we require these providers to protect your information, we are not responsible for their privacy practices."
        ]
      },
      {
        "heading": "13. US STATE PRIVACY RIGHTS",
        "paragraphs": [
          "13.1 Applicability",
          "As of 2026, twenty US states have enacted comprehensive consumer privacy laws that are now in effect. If you are a resident of one of these states, you may have specific privacy rights under your state's law.",
          "States with comprehensive privacy laws in effect: California, Colorado, Connecticut, Delaware, Florida, Indiana, Iowa, Kentucky, Maryland, Minnesota, Montana, Nebraska, New Hampshire, New Jersey, Oregon, Rhode Island, Tennessee, Texas, Utah, and Virginia.",
          "While each state law has unique provisions, most provide similar core rights as described below.",
          "13.2 Your Privacy Rights",
          "Depending on your state of residence, you may have the following rights:",
          "Right to Know / Access",
          "Request information about:",
          "Categories of personal information we collect about you",
          "Sources from which we collect personal information",
          "Business or commercial purposes for collecting, selling, or sharing personal information",
          "Categories of third parties with whom we share personal information",
          "Specific pieces of personal information we have collected about you",
          "Whether your personal information is sold or shared and to whom",
          "Right to Correct",
          "Request correction of inaccurate personal information we maintain about you.",
          "Right to Delete",
          "Request deletion of personal information we have collected from you, subject to certain legal exceptions.",
          "Important: We delete account data as described in this Privacy Policy, subject to limited legal, safety, backup, and abuse-prevention exceptions. We may not be able to delete:",
          "Short-term deletion records retained for up to 90 days",
          "Aggregated or de-identified information that no longer identifies you",
          "Information required for legal compliance or dispute resolution",
          "Security logs and backup snapshots until they expire under our normal retention schedule",
          "We will delete what we can consistent with legal exceptions and will explain what cannot be deleted and why.",
          "Right to Data Portability",
          "Request a copy of your personal information in a portable and, to the extent technically feasible, readily usable format that allows you to transmit the data to another entity without hindrance.",
          "Right to Opt-Out",
          "You have the right to opt-out of:",
          "Sale of Personal Information: We do not currently sell personal information in the traditional commercial sense. However, under some state definitions, sharing data with AI platforms for training purposes may be considered a \"sale.\" You may opt-out of this sharing by contacting us at privacy@betterintentions.com. You can also record a \"do not sell or share\" opt-out at any time — automatically via the Global Privacy Control browser signal, on our \"Your Privacy Choices\" page (betterintentions.com/privacy-choices), or in Settings.",
          "Targeted Advertising: When we implement advertising features, you will be able to opt-out of the processing of your personal information for targeted advertising purposes.",
          "Profiling/Automated Decision-Making: If we use your personal information for profiling in furtherance of decisions that produce legal or similarly significant effects, you can opt-out of such processing (where required by state law).",
          "Right to Non-Discrimination",
          "You have the right not to receive discriminatory treatment for exercising your privacy rights, including:",
          "Denying goods or services",
          "Charging different prices or rates",
          "Providing a different level or quality of goods or services",
          "Suggesting you will receive different prices, rates, levels, or quality",
          "Right to Limit Use of Sensitive Personal Information",
          "Some state laws provide rights to limit the use of \"sensitive\" personal information. Information we collect that may be considered sensitive includes:",
          "Precise geolocation data (if collected)",
          "Racial or ethnic origin (if voluntarily provided)",
          "Religious beliefs (if voluntarily provided)",
          "Sexual orientation",
          "You may request that we limit our use of this information to purposes necessary to provide our services.",
          "Appeal Rights",
          "If we deny your privacy rights request, you have the right to appeal that decision. We will provide information about how to appeal when we respond to your request.",
          "13.3 Exercising Your Rights",
          "To exercise any of these rights:",
          "Submit a Request:",
          "Email: privacy@betterintentions.com",
          "Mail: BetterIntentions, LLC, 2388 Immokalee Rd., #277, Naples, Florida 34110",
          "Information to Include:",
          "Your full name and email address associated with your account",
          "Your state of residence",
          "Specific right(s) you wish to exercise",
          "Sufficient detail to allow us to locate your information",
          "Identity Verification: We will verify your identity before processing requests to protect your privacy and security. Verification may include:",
          "Confirming your email address",
          "Matching information you provide with information in our records",
          "Additional verification for sensitive requests",
          "Authorized Agents: You may designate an authorized agent to make requests on your behalf. The agent must provide proof of authorization, and we may require you to verify your identity directly with us.",
          "Response Timeframe: We will respond to verified requests within 45 days (or as otherwise required by applicable state law). If we need additional time, we will notify you and explain the reason for the extension.",
          "No Fee: We do not charge a fee to process or respond to your privacy rights request unless it is excessive, repetitive, or manifestly unfounded. If we determine a fee is warranted, we will notify you and provide a cost estimate before completing your request.",
          "13.4 California-Specific Rights",
          "California residents have additional rights under the California Consumer Privacy Act (CCPA) and California Privacy Rights Act (CPRA):",
          "Financial Incentives",
          "We do not currently offer financial incentives or price differences related to the collection, retention, or sale of personal information.",
          "Shine the Light Law",
          "California's \"Shine the Light\" law permits California residents to request information about disclosures of personal information to third parties for their direct marketing purposes. We do not currently disclose personal information to third parties for their direct marketing purposes.",
          "Minors Under 16",
          "We do not knowingly sell or share personal information of consumers under 16 years of age without affirmative authorization. Our minimum age is 16 years old, and we do not currently engage in sales that would trigger opt-in requirements.",
          "13.5 Virginia, Colorado, and Connecticut-Specific Provisions",
          "If you are a resident of Virginia, Colorado, or Connecticut, you have the right to appeal our decision regarding your privacy rights request by contacting us at privacy@betterintentions.com within a reasonable time after receiving our decision. In your appeal, please include your original request details and explain why you believe our decision was incorrect.",
          "13.6 Processing Purposes and Data Sharing",
          "For transparency regarding state privacy law compliance:",
          "Categories of Personal Information Collected:",
          "Identifiers (name, email, phone, display name choice)",
          "Demographic information (age, gender, location, occupation, political affiliation, sexual orientation)",
          "Belief attributes (positions on social and political issues)",
          "User-generated content (messages, profile information)",
          "Usage data (search queries, features used, interaction patterns)",
          "Device and technical information (IP address, browser type, device identifiers)",
          "Business/Commercial Purposes:",
          "Providing and maintaining Platform services",
          "User authentication and account management",
          "Facilitating user discovery and messaging",
          "Safety and security (content moderation, fraud prevention)",
          "Platform improvement and analytics",
          "AI and machine learning training and development",
          "Targeted advertising (future implementation)",
          "Legal compliance and dispute resolution",
          "Categories of Third Parties with Whom We Share:",
          "Service providers (hosting, moderation, communications, analytics)",
          "AI and machine learning platforms (for model training)",
          "Law enforcement and government agencies (when legally required)",
          "Business transaction parties (in event of merger, acquisition, etc.)",
          "\"Sale\" or \"Sharing\" Under State Laws: Our sharing of data with AI platforms for training purposes may constitute a \"sale\" or \"share\" under certain state definitions. You can opt-out as described in Section 13.2.",
          "13.7 Retention Periods",
          "We retain personal information only as long as reasonably necessary for the purposes for which it was collected:",
          "Platform integrity and safety",
          "Legal compliance and protection",
          "AI training and development",
          "Audit and security purposes",
          "After voluntary account deletion, only a 90-day forensic record (hashed identifiers plus the deletion-request IP) is retained and then purged; for accounts disabled for a policy violation, hashed identifiers are retained to prevent re-registration. No other personal data is retained after deletion.",
          "13.8 Contact for State Privacy Rights",
          "For all state privacy rights inquiries, requests, or appeals:",
          "Email: privacy@betterintentions.com\nSubject Line: \"State Privacy Rights Request - [Your State]\"\nMail: BetterIntentions, LLC Attn: Privacy Officer, 2388 Immokalee Rd., #277, Naples, FL 34110",
          "We are committed to complying with all applicable state privacy laws and will update this policy as new laws take effect or existing laws are amended.",
          "13.9 State-Specific Additional Requirements",
          "While most state privacy laws follow similar frameworks, certain states have unique requirements:",
          "Oregon - Specific Third-Party Disclosure",
          "Oregon residents have the right to request a list of the specific third parties to whom we have disclosed their personal data (not just categories). To exercise this right, contact us at privacy@betterintentions.com.",
          "Specific third parties we share data with include:",
          "Amazon Web Services (AWS), United States regions us-east-1 and us-east-2",
          "Amazon Comprehend, United States AWS regions",
          "Amazon Simple Email Service (SES v2), United States AWS regions",
          "Not currently used; if enabled later, the provider and location will be disclosed before use",
          "Not currently used; no third-party AI/ML model-training platform receives identifiable user data",
          "Amazon CloudWatch, United States AWS regions",
          "We will update this list as our service providers change and provide Oregon residents with current information upon request.",
          "Iowa - Narrow \"Sale\" Definition",
          "Iowa defines \"sale\" more narrowly than other states, requiring monetary consideration. Under Iowa law, our sharing of data with AI platforms for training purposes may NOT constitute a \"sale\" since we do not receive direct monetary payment for this sharing. However, you may still opt-out of AI data sharing by contacting us at privacy@betterintentions.com.",
          "Montana - Enhanced Protections for Ages 13-15",
          "Montana law provides heightened privacy protections for consumers aged 13-15. Our Platform is intended for users aged 16 and older, so we do not knowingly collect information from Montana consumers aged 13-15.",
          "Obtain consent for processing sensitive data of any Montana resident under 18 if onboarded in error",
          "Provide additional disclosure about data use for this age group",
          "Limit certain data processing activities for any Montana resident under 18 if onboarded in error",
          "Texas and Nebraska - No Numerical Thresholds",
          "Texas and Nebraska privacy laws apply to all persons conducting business in their states who process or sell personal data and are not federally-defined small businesses, regardless of the number of consumers whose data is processed. As we grow, we will comply with these laws' requirements even if we don't meet other states' numerical thresholds.",
          "Florida - Limited Applicability",
          "Florida's Digital Bill of Rights applies only to entities with $1 billion+ in annual revenue that meet specific additional criteria. Our Platform does not currently meet Florida's applicability thresholds. If this changes in the future, we will update this policy and implement Florida-specific requirements, including data retention schedules.",
          "Delaware and New Hampshire - Lower Thresholds",
          "Delaware and New Hampshire have lower applicability thresholds (35,000 consumers for Delaware; 35,000 for New Hampshire) compared to other states. We will comply with these laws' requirements as our user base grows, including:",
          "Limiting data collection to what is adequate, relevant, and reasonably necessary",
          "Obtaining consent for sensitive data processing",
          "Honoring opt-out preference signals",
          "Colorado, Montana, and Connecticut - Universal Opt-Out Mechanisms",
          "These states require that we recognize and honor universal opt-out preference signals (also called \"global privacy controls\") that you may set in your browser or device. We detect and honor the Global Privacy Control (GPC) browser signal today, for all users regardless of state: when your browser sends the signal, we record a \"do not sell or share\" opt-out for that browser and, if you are signed in, on your account. You can review the signal's status and manage your opt-out at any time on our \"Your Privacy Choices\" page (betterintentions.com/privacy-choices) or, for members, in Settings.",
          "Connecticut - Expanded Scope (Effective July 2026)",
          "Connecticut's law expands significantly in 2026 to cover:",
          "Any processing of sensitive data",
          "Any business offering personal data for sale. These expansions have no numerical minimums, meaning Connecticut's law may apply more broadly to our Platform.",
          "Multiple States - Data Protection Assessments",
          "The following states require us to conduct data protection assessments (DPAs) for certain high-risk processing activities: California, Colorado, Connecticut, Delaware, Indiana, Kentucky, Maryland, Minnesota, Montana, Nebraska, New Hampshire, New Jersey, Oregon, Rhode Island, Tennessee, Texas, and Virginia.",
          "When applicable, we will conduct DPAs for:",
          "Processing for targeted advertising purposes (when implemented)",
          "Selling or sharing personal data (including AI data sharing) (when implemented)",
          "Processing sensitive data (when implemented)",
          "Profiling that presents reasonably foreseeable risk of harm",
          "These assessments evaluate the benefits of processing against potential risks to consumers and identify appropriate safeguards.",
          "State-Specific Definitions of \"Sensitive Data\"",
          "While most states have similar definitions of sensitive data, some variations exist:",
          "Oregon and Montana: Broader definitions including union membership",
          "California: Includes \"sensitive personal information\" category under CPRA",
          "Multiple states: Include precise geolocation data (we collect general location only)",
          "We treat the broadest definition of sensitive data consistently across all states.",
          "State Enforcement and Cure Periods",
          "Enforcement varies by state:",
          "California: Dedicated Privacy Protection Agency with rulemaking authority",
          "Colorado and New Jersey: State agencies with rulemaking authority",
          "Most other states: Attorney General enforcement",
          "Cure periods: Some states provide 30-60 day cure periods for first violations (Delaware, Iowa, Nebraska, New Hampshire have time-limited cure periods that expire)",
          "We take compliance seriously and aim to cure any violations promptly if notified.",
          "Future State Law Changes",
          "State privacy laws continue to evolve with frequent amendments and new effective dates. We monitor these changes and update our practices accordingly.",
          "We will update this Privacy Policy to reflect material changes in state privacy law requirements."
        ]
      },
      {
        "heading": "14. CHANGES TO THIS PRIVACY POLICY",
        "paragraphs": [
          "14.1 Updates",
          "We may update this Privacy Policy from time to time to reflect:",
          "Changes in our practices",
          "New features or services",
          "Legal or regulatory requirements",
          "User feedback",
          "14.2 Notice of Changes",
          "We will notify you of material changes by:",
          "Posting the updated Privacy Policy on the Platform",
          "Updating the \"Last Updated\" date",
          "Sending email notification (for significant changes)",
          "Displaying a prominent notice on the Platform",
          "14.3 Continued Use",
          "Your continued use of the Platform after changes are posted constitutes acceptance of the updated Privacy Policy."
        ]
      },
      {
        "heading": "15. CONTACT US",
        "paragraphs": [
          "15.1 Privacy Questions",
          "If you have questions, concerns, or requests regarding this Privacy Policy or our privacy practices, please contact us:",
          "Privacy Contact:\nEmail: privacy@betterintentions.com\nMailing Address:\nBetterIntentions, LLC\n2388 Immokalee Rd., #277\nNaples, Florida 34110",
          "Response Time: We aim to respond to all privacy inquiries within 20 business days."
        ]
      }
    ]
  },
  communityGuidelines: {
    key: "communityGuidelines",
    path: "/community-guidelines",
    title: "Community Guidelines",
    version: "2026-04-21",
    effectiveDate: "April 21, 2026",
    lead:
      "Better Intentions is built for respectful introductions and conversation. These guidelines explain the minimum conduct expected from every user.",
    sections: [
      {
        heading: "Respect and safety",
        paragraphs: [
          "Treat other people respectfully. Harassment, hate, threats, stalking, coercion, and sexual exploitation are not allowed.",
          "Do not use the platform to target, pressure, or deceive other users.",
        ],
      },
      {
        heading: "Authenticity",
        paragraphs: [
          "Use accurate account information and do not impersonate another person, organization, or affiliation.",
          "Do not use automated tools, scraping, or spam tactics to interact with the service or its users.",
        ],
      },
      {
        heading: "Reporting and enforcement",
        paragraphs: [
          "Users may report profiles or messages. Better Intentions may restrict access, remove visibility, or disable accounts when needed to protect the community.",
        ],
      },
    ],
  },
  cookiePolicy: {
    key: "cookiePolicy",
    path: "/cookie-policy",
    title: "Cookie Policy",
    version: "2026-04-21",
    effectiveDate: "April 21, 2026",
    lead:
      "Better Intentions uses browser storage and similar technologies to keep sessions working, remember interface state, and support core site functionality.",
    sections: [
      {
        heading: "What we use",
        paragraphs: [
          "We use authentication-related storage, interface state, and operational browser storage needed for security flows, session continuity, and basic user experience.",
        ],
      },
      {
        heading: "How it is used",
        paragraphs: [
          "These technologies help the site keep you signed in, maintain app state, support onboarding or walkthrough progress, and remember certain local choices made during account flows.",
        ],
      },
      {
        heading: "Your choices",
        paragraphs: [
          "Blocking required browser storage may prevent key parts of Better Intentions from working correctly, including authentication and messaging-related experiences.",
        ],
      },
    ],
  },
});

export function getLegalDocument(documentKey) {
  const normalizedKey = String(documentKey || "").trim();
  if (!normalizedKey) return null;
  return LEGAL_DOCUMENTS[normalizedKey] || null;
}
